module.exports = __webpack_public_path__ + "static/videoshopify-117c2d85b5fd05b18b2721ec76fc9dd5.mp4";